export const dashboardSx = {
    root: {
        mx: 'auto',
        maxWidth: '1500px'
    }
}